// Phase 3 §1 + §2 — Light/Dark theme.
// The active theme is written to `<html data-theme="light|dark">` so the CSS
// can swap palette variables via a single selector (see [data-theme="light"]
// rules in styles.css). Preference persists in localStorage. First-ever load
// defaults to "light" so the login page (which is the first thing a new user
// sees) starts in the light palette per §2.

import React, { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "gabruz-theme";
const ThemeCtx = createContext(null);

function applyTheme(theme) {
  if (typeof document !== "undefined") {
    document.documentElement.dataset.theme = theme;
  }
}

function readInitialTheme() {
  if (typeof localStorage === "undefined") return "light";
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved === "dark" || saved === "light" ? saved : "light";
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(readInitialTheme);

  useEffect(() => { applyTheme(theme); }, [theme]);

  function setTheme(next) {
    setThemeState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* ignore */ }
  }
  function toggleTheme() { setTheme(theme === "light" ? "dark" : "light"); }

  return (
    <ThemeCtx.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeCtx);
  if (!ctx) throw new Error("useTheme must be used inside <ThemeProvider>");
  return ctx;
}
